<template>
<section class="search_box">
  <div class="content_wrap">
    <form name="form" id="search_form" class="form_wrap">
      <div class="form_clm">
        <h2>エリアで絞り込む</h2>
        <div class="pref select_wrap">
          <select name="pref_id" v-model="selectedPref">
            <option value="" selected>都道府県を選択してください</option>
            <option v-for="pref in this.prefs" :key="pref.id" :value="pref.id">{{pref.name}}</option>
          </select>
          <i class="material-icons">keyboard_arrow_down</i>
        </div>
      </div><!-- /.form_clm -->
      <div class="form_clm">
        <h2>カテゴリーで絞り込む</h2>
        <div class="cat radio_wrap">
          <div class="cat_type">
            <input type="radio" name="type" id="type_1" value="salon" v-model="selectedType">
            <label for="type_1" id="label_type_1" class="radio">&#035; 認定ネイルサロン</label>
          </div>
          <div class="cat_type">
            <input type="radio" name="type" id="type_2" value="school" v-model="selectedType">
            <label for="type_2" id="label_type_2" class="radio">&#035; 認定校</label>
          </div>
          <div class="cat_type">
            <input type="radio" name="type" id="type_3" value="corporate" v-model="selectedType">
            <label for="type_3" id="label_type_3" class="radio">&#035; ネイル関連企業</label>
          </div>
        </div>
      </div><!-- /.form_clm -->
      <div class="form_clm">
        <h2>キーワードで絞り込む</h2>
        <div class="keyword text_wrap">
          <label class="field_box" for="sns_keyword">
              <input name="keyword" type="text" id="sns_keyword" value="" class="textbox" pattern=".{1,50}" v-model="inputKeyword" :placeholder="keywordph">
          </label>
        </div>
      </div><!-- /.form_clm -->
      <div class="form_clm">
        <button class="btn">検索<i class="material-icons">keyboard_arrow_right</i></button>
      </div><!-- /.form_clm -->
    </form>
  </div><!-- /.content_wrap -->
</section><!-- /.search_box -->
</template>

<script>
export default {
    props: {
      pref: String,
      type: String,
      keyword: String,
      keywordph:{
        type:String,
        default:"キーワードを入力",
      },
    },
    data() {
      return {
        selectedPref: null,
        selectedType: null,
        inputKeyword: '',
      };
    },
    created() {
      this.selectedPref = this.pref;
      this.selectedType = this.type;
      this.inputKeyword = this.keyword;
    },
    updated() {

    }
}
</script>